import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const getEmployeeList = createAsyncThunk(
  'school-attendance-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-attendance/employee/list`, {
        params, // 👈
      })
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const createEmployeeAttendance = createAsyncThunk(
  'school-attendance-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-attendance/employee/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const createEmployeePartialLeave = createAsyncThunk(
  'store-employee-partial-leave',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-attendance/employee/partial/leave`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const employeeLeavesList = createAsyncThunk(
  'school-employee-leave-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-employee-leave/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createEmployeeLeave = createAsyncThunk(
  'create-school-employee-leave',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-employee-leave/employee/leave`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editEmployeeLeave = createAsyncThunk(
  'school-employee-leave-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-employee-leave/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const approveEmployeeLeave = createAsyncThunk(
  'school-employee-leave-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-employee-leave/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteEmployeeLeave = createAsyncThunk(
  'school-employee-leave-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-employee-leave/delete/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getEmployeeAttendance = createAsyncThunk(
  'school-employee-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-attendance/employee/attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getEmployeeAttendanceReport = createAsyncThunk(
  'school-attendance-report',
  async (data: {year: number; month: number}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-attendance/report`, {
        params: data,
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getEmployeeAttendancePayroll = createAsyncThunk(
  'school-attendance-payroll',
  async (data: {employee_id: string[]; year: number; month: number}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-attendance/payroll`, {
        params: data,
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeEmployeeAttendancePayroll = createAsyncThunk(
  'school-attendance-payroll-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-attendance/payroll/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const exportPayrollExcel = createAsyncThunk(
  'school-attendance-payroll-excel',
  async (params: {year: number; month: number}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-attendance/payroll/excel/report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const exportExcelAtt = createAsyncThunk('exp-att', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-attendance/export-att`, data, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Emp Attendance.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const ImportExcelAttendance = createAsyncThunk('imp-att', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-attendance/import-att`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type AttendanceState = {
  errors: any
}

const initialState: AttendanceState = {
  errors: '',
}

export const attendanceSlice = createSlice({
  name: 'school-attendance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createEmployeeAttendance.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(
      storeEmployeeAttendancePayroll.rejected,
      (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      }
    )
  },
})

export const {reset} = attendanceSlice.actions
export default attendanceSlice.reducer
